<button class='menu-icon' [class.dark]='colorScheme === "dark"' [class.light]='colorScheme === "light"' (click)='menu.active = true'
        role='button' aria-label='הצגת התפריט הראשי' [attr.aria-expanded]='menu.active ? "true" : null'
></button>
